/* Number / text helpers shared by pages. */
export const round2 = (n) => Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;
export const n0 = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
export const n2 = (v) => Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

/** Print an HTML document through a hidden iframe (no popup, so popup blockers can't stop it). */
export function printHtml(html) {
  const frame = document.createElement("iframe");
  Object.assign(frame.style, { position: "fixed", right: 0, bottom: 0, width: 0, height: 0, border: 0 });
  document.body.appendChild(frame);
  const doc = frame.contentWindow.document;
  doc.open(); doc.write(html); doc.close();
  setTimeout(() => {
    frame.contentWindow.focus();
    frame.contentWindow.print();
    setTimeout(() => frame.remove(), 1000);
  }, 250);
}
